import { jsx } from 'react/jsx-runtime';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';
import rtlPlugin from 'stylis-plugin-rtl';
import { useTheme } from '@mui/material';

const cacheLtr = createCache({
    key: 'muiltr',
});
const cacheRtl = createCache({
    key: 'muirtl',
    stylisPlugins: [prefixer, rtlPlugin],
});
const DirectionCacheProvider = ({ children }) => {
    const theme = useTheme();
    return jsx(CacheProvider, Object.assign({ value: theme.direction === 'rtl' ? cacheRtl : cacheLtr }, { children: children }));
};

export { DirectionCacheProvider as default };
//# sourceMappingURL=DirectionCacheProvider.js.map
